import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider, Route, Link } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import App from './Pages/App';
import Map from './Pages/Map';
import Login from './Pages/Login';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />
  },
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/map",
    element: <Map />
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

document.title = "VMI Panel";

root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
